import { Highlight } from '@mantine/core';
import { Icon, type CustomIconName } from '@/components/Icon/Icon';
import type { Suggestion, SuggestionTypes } from '@/features/searchSlice';
import classes from './SearchBar.module.css';

const ICON_BY_GROUP: Record<SuggestionTypes, CustomIconName> = {
  Addresses: 'PinAlt',
  Poles: 'Pole',
  Spans: 'Span',
  Coordinates: 'PinAlt',
  SpansInternal: 'Span',
};

export const OptionLabel = ({
  group,
  suggestion,
  searchTerm,
}: {
  group: SuggestionTypes;
  suggestion: Suggestion;
  searchTerm: string;
}) => (
  <div className={classes.option}>
    <Icon name={ICON_BY_GROUP[group]} />
    <div className={classes.optionLabel}>
      <Highlight
        component="div"
        className={classes.optionValue}
        highlight={searchTerm}
      >
        {suggestion.value}
      </Highlight>
      {suggestion.subtitle && (
        <div className={classes.optionSubtitle}>{suggestion.subtitle}</div>
      )}
    </div>
  </div>
);
